// Owner-approved Natively external-ID mode, not JWT identity verification.
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { bindOneSignalIdentity, isInsideNativeApp, logoutOneSignalIdentity } from "@/lib/onesignal-native";

export { isNativePushAvailable, logoutOneSignalIdentity } from "@/lib/onesignal-native";

interface AuthMeResponse {
  user: { id: number; approved?: boolean; status?: string } | null;
  impersonating?: boolean;
  isResidentMember?: boolean;
}

export function useOneSignalIdentity() {
  const { data, error, dataUpdatedAt } = useQuery<AuthMeResponse>({
    queryKey: ["/api/app/auth/me"],
    refetchInterval: isInsideNativeApp() ? 30_000 : false,
    refetchOnWindowFocus: "always",
  });

  useEffect(() => {
    if (!isInsideNativeApp()) return;
    // Errors override cached successful data; never bind while impersonating.
    if (error || data?.impersonating || data?.isResidentMember || !data?.user?.id ||
        data.user.approved === false || (data.user.status && data.user.status !== "active")) {
      logoutOneSignalIdentity();
      return;
    }
    bindOneSignalIdentity(`host-${data.user.id}`);
  }, [data?.user?.id, data?.user?.approved, data?.user?.status, data?.impersonating,
      data?.isResidentMember, error, dataUpdatedAt]);
}
